import { InfoCircleOutlined } from '@ant-design/icons';
import { Button, Card, Flex, Tooltip, Typography } from 'antd';
import React, { useState } from 'react';
import styled from 'styled-components';
import { SurveyUploadType, UserRoleType } from '../../../../constants';
import useParams from '../../../../hooks/useParams';
import useRoles from '../../../../hooks/useRoles';
import { summaryType, surveyType } from '../../../../types';
import EditSurveySummaryModal from './EditSurveySummaryModal';

const { Title, Text } = Typography;

const StyledTitle = styled(Title)`
  margin-top: 8px;
`;

const StyledText = styled(Text)`
  white-space: pre-line;
`;

function SurveySummary({ survey, summary }) {
  const { surveyId } = useParams();
  const { roles } = useRoles();

  const [isEditModalVisible, setEditModalVisible] = useState(false);

  return (
    <>
      <Flex justify="space-between" align="baseline" gap={8}>
        <Flex align="baseline" gap={8}>
          <StyledTitle level={4}>
            {survey.upload_type === SurveyUploadType.SURVEY
              ? 'Survey insights'
              : 'Interview insights'}
          </StyledTitle>
          <Tooltip title="Summary is generated by an AI model based on questions, themes, and responses">
            <InfoCircleOutlined />
          </Tooltip>
        </Flex>
        {(roles.includes(UserRoleType.ADMINISTRATOR) || roles.includes(UserRoleType.EDITOR)) && (
          <Button size="small" onClick={() => setEditModalVisible(true)}>
            Edit summary
          </Button>
        )}
      </Flex>
      <Card>
        <StyledText>{summary.summary}</StyledText>
      </Card>
      <EditSurveySummaryModal
        visible={isEditModalVisible}
        closeModal={() => setEditModalVisible(false)}
        summary={summary.summary}
        surveyId={surveyId}
      />
    </>
  );
}

SurveySummary.propTypes = {
  survey: surveyType.isRequired,
  summary: summaryType.isRequired,
};

export default SurveySummary;
